export { default } from './SkeletonRectangle';

export * from './SkeletonRectangle.types';
